import script from "./View.vue?vue&type=script&setup=true&lang=js"
export * from "./View.vue?vue&type=script&setup=true&lang=js"

import "./View.vue?vue&type=style&index=0&id=dd462e5a&lang=css"
import "./View.vue?vue&type=style&index=1&id=dd462e5a&scoped=true&lang=css"
import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd462e5a"]])

export default __exports__